import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider, useAuth } from './contexts/AuthContext'
import { ConfigProvider } from './contexts/ConfigContext'
import Layout from './components/Layout'
import LayoutSemNavbar from './components/LayoutSemNavbar'
import Login from './pages/Login'
import Home from './pages/Home'
import Dashboard from './pages/Dashboard'
import Clientes from './pages/Clientes'
import Apolices from './pages/Apolices'
import Propostas from './pages/Propostas'
import FluxoCaixa from './pages/FluxoCaixa'
import CRM from './pages/CRM'
import Cadastro from './pages/Cadastro'
import Indicacoes from './pages/Indicacoes'
import Sinistros, { SinistroTerceiroPage } from './pages/Sinistros'
import Assistencias from './pages/Assistencias'
import Comissoes from './pages/Comissoes'
import RecibosSocios from './pages/RecibosSocios'
import Renovacoes from './pages/Renovacoes'
import Perdidos from './pages/Perdidos'
import ParcelasAtraso, { ParcelasAtrasoTelaCheia } from './pages/ParcelasAtraso'
import { AvisosHost } from './components/Avisos'
import { ConferirClienteHost } from './components/ConferirCliente'
import './index.css'

// Bloqueia acesso direto por URL a uma pagina cujo modulo o usuario nao tem liberado (o menu ja
// nao mostra o link, mas sem isso bastaria digitar a URL pra abrir a tela mesmo assim).
// `modulo` pode ser uma lista (basta ter acesso a uma — ex.: Cadastros, que tem uma chave por aba).
function RotaComAcesso({ modulo, children }) {
  const { temAcesso, rotaInicial } = useAuth()
  const modulos = Array.isArray(modulo) ? modulo : [modulo]
  if (!modulos.some(temAcesso)) return <Navigate to={rotaInicial()} replace />
  return children
}

// cad_admin nao existe na lista de telas: admin/gerente passam em qualquer chave, entao isso libera
// /cadastro pra eles mesmo sem nenhuma aba comum (Usuários/Corretora/Log).
const MODULOS_CADASTRO = ['cad_seguradoras', 'cad_ramos', 'cad_coberturas', 'cad_comissao', 'cad_financeiro', 'cad_emails', 'cad_admin']

function SemAcesso() {
  return <div className="page-content" style={{ padding: 40, color: '#888' }}>Seu usuário ainda não tem acesso a nenhuma tela. Fale com o administrador.</div>
}

export default function App() {
  return (
    <ConfigProvider>
      <AvisosHost />
      <ConferirClienteHost />
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route element={<Layout />}>
              <Route path="/home" element={<RotaComAcesso modulo="home"><Home /></RotaComAcesso>} />
              <Route path="/sem-acesso" element={<SemAcesso />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/clientes" element={<RotaComAcesso modulo="clientes"><Clientes /></RotaComAcesso>} />
              <Route path="/apolices" element={<RotaComAcesso modulo="apolices"><Apolices /></RotaComAcesso>} />
              <Route path="/propostas" element={<RotaComAcesso modulo="propostas"><Propostas /></RotaComAcesso>} />
              <Route path="/renovacoes" element={<RotaComAcesso modulo="renovacoes"><Renovacoes /></RotaComAcesso>} />
              <Route path="/perdidos" element={<RotaComAcesso modulo="crm"><Perdidos /></RotaComAcesso>} />
              <Route path="/fluxo-caixa" element={<RotaComAcesso modulo="fluxo_caixa"><FluxoCaixa /></RotaComAcesso>} />
              <Route path="/parcelas-atraso" element={<RotaComAcesso modulo="parcelas_atraso"><ParcelasAtraso /></RotaComAcesso>} />
              <Route path="/crm" element={<RotaComAcesso modulo="crm"><CRM /></RotaComAcesso>} />
              <Route path="/funil" element={<RotaComAcesso modulo="crm"><CRM /></RotaComAcesso>} />
              <Route path="/cadastro" element={<RotaComAcesso modulo={MODULOS_CADASTRO}><Cadastro /></RotaComAcesso>} />
              <Route path="/relatorios/indicacoes" element={<RotaComAcesso modulo="indicacoes"><Indicacoes /></RotaComAcesso>} />
              <Route path="/sinistros" element={<RotaComAcesso modulo="sinistros"><Sinistros /></RotaComAcesso>} />
              <Route path="/sinistros/terceiro/:terceiroId" element={<RotaComAcesso modulo="sinistros"><SinistroTerceiroPage /></RotaComAcesso>} />
              <Route path="/assistencias" element={<RotaComAcesso modulo="assistencias"><Assistencias /></RotaComAcesso>} />
              <Route path="/comissoes" element={<RotaComAcesso modulo="comissoes"><Comissoes /></RotaComAcesso>} />
              <Route path="/recibo-socios" element={<RecibosSocios />} />
              <Route path="*" element={<Navigate to="/home" />} />
            </Route>
            <Route element={<LayoutSemNavbar />}>
              <Route path="/parcelas-atraso/tela-cheia" element={<RotaComAcesso modulo="parcelas_atraso"><ParcelasAtrasoTelaCheia /></RotaComAcesso>} />
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </ConfigProvider>
  )
}
